export const model = {
    id: null,
    name: '',   
    state_id: '', 
    created_at: '',
    updated_at: ''
};
